var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Top"},[_c('div',{staticClass:"flex"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/Web/logo.png")},on:{"click":_vm.course}}),_c('div',{staticStyle:{"display":"flex"},on:{"click":_vm.course}},[_c('div',{staticClass:"line"}),_vm._m(0)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item"},[_c('span',[_vm._v("COURSE")]),_c('span',[_vm._v("课程")])])
}]

export { render, staticRenderFns }